import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import $ from 'jquery';
import { addUserServicesBatch, updateOnBoardingStep } from '../../../../actions/user-api';
import { useDispatch, useSelector } from 'react-redux';
import * as Loadings from '../../../../constants/loadings/user';
import * as R from 'ramda';
import {CommonServices, PersonalServices, SocialNetworksOptions, AssuranceOptions, OtherService, ConnectionTypes} from '../../../../constants/utils/connectionTypes';
import {LoadingState} from '../../../../_common/loadingState';

export const Step4 = ({ monServiceRequirements, setMonServiceRequirements }) => {
    const history = useHistory();
    const [subStep, setSubStep] = useState(1);
    const user = useSelector(state => state.user);
    const [redirect, setRedirect] = useState(false);
    const dispatch = useDispatch();

    const [selectedServices, setSelectedServices] = useState([
        CommonServices.notaire, CommonServices.secSocial, CommonServices.bank, CommonServices.mutuelle, CommonServices.habitation,
        CommonServices.eau, CommonServices.electricity, CommonServices.mobile, CommonServices.impots, CommonServices.caf
    ]);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subStep]);

    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user.services) && user.services.filter(s => s.connectionType !== ConnectionTypes.activity && s.connectionType !== ConnectionTypes.otherActivity && s.connectionType !== ConnectionTypes.pension && s.connectionType !== ConnectionTypes.poleEmploi).length > 0) {
            setSelectedServices(user.services);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.services, user.services.length]);

    useEffect(() => {
        let hasCommon = selectedServices.filter(s => Object.values(CommonServices).findIndex(service => service.connectionType === s.connectionType) !== -1).length > 0;
        let hasPersonnal = selectedServices.filter(s => Object.values(CommonServices).findIndex(service => service.connectionType === s.connectionType) === -1).length > 0;
        setMonServiceRequirements({ ...monServiceRequirements, common: hasCommon, personnal: hasPersonnal });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedServices.length]);

    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user.services) && user.services.filter(s => s.connectionType !== ConnectionTypes.activity &&  s.connectionType !== ConnectionTypes.otherActivity && s.connectionType !== ConnectionTypes.pension && s.connectionType !== ConnectionTypes.poleEmploi).length > 0 && selectedServices.filter(s => s.connectionType !== ConnectionTypes.activity &&  s.connectionType !== ConnectionTypes.otherActivity && s.connectionType !== ConnectionTypes.pension && s.connectionType !== ConnectionTypes.poleEmploi).length === 9) {
            setSelectedServices(user.services);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subStep]);


    if (redirect === true && !user.isLoading.includes(Loadings.UPDATING_SERVICES) && user.signupStep4Success === true) {
        let tmpUser = user.user;
        let step = !R.isNil(user) && !R.isNil(tmpUser) && !R.isNil(tmpUser.onBoardingStep) ? parseInt(JSON.stringify(tmpUser.onBoardingStep).replace(/\D/g, "")) : -1;
        if (step !== 6 && step !== -1) {
            if (tmpUser.onBoardingStep === "Completed") {
                step = 6;
            }
        }
        if (step >= 4) {
            setRedirect(false);
            history.push("/auth/signup/step5");
        }
    }

    function AddOrRemove(option) {
        let tmpSelected = JSON.parse(JSON.stringify(selectedServices));
        if (tmpSelected.findIndex(o => o.connectionType === option.connectionType) !== -1) {
            tmpSelected = tmpSelected.filter(o => o.connectionType !== option.connectionType);
        }
        else {
            tmpSelected.push(option);
        }
        setSelectedServices(tmpSelected);
    }

    if (user.isLoading.includes(Loadings.FETCH_SERVICES)) {
        return <LoadingState/>;
    }

    function personalService(srv, index){
        return (
            <div key={index + srv.title} className="form-group col col-lg-3 col-xl-2">
                <div className={"card p-2 text-center picker-card" + (selectedServices.findIndex(s => s.connectionType === srv.connectionType) !== -1 ? ' active' : '')} onClick={() => { AddOrRemove(srv); }}>
                    <img className={"img-fluid mx-auto mb-1 h-6 py-1" + (subStep === 1 ? ' mt-sm mb-3' : ' mt-auto')} src={srv.icon} alt={srv.title} />
                    <h2 className={"h6 text-uppercase font-weight-bolder" + (subStep === 1 ? ' my-auto' : ' mt-auto')}>{srv.title}</h2>
                    {
                        !R.isNil(srv.desc) && srv.desc !== "" ?
                            <p className="small o-50 mt-0 mb-auto lh-copy h-6">{srv.desc.map((d, ind) => { return <React.Fragment key={ind}>{d}{ind !== (srv.desc.length - 1) ? <br /> : ''}</React.Fragment> })}</p>
                        :
                            ''
                    }
                    
                </div>
            </div>
        )
    }
    

    return (
        <article className="view-calc pt-0 mb-auto">
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center py-2">
                    <h1 className="text-primary font-weight-bolder mt-2 mb-2">{subStep === 1 ? 'Organismes de bases' : 'Organismes complémentaires'}</h1>                    
                </header>
            </div>
            {subStep === 1 ?
                <div className="auto-view py-4 py-lg-0 mt-lg-sm">
                    <div className="container-fluid">
                        <section className="block">
                            <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-0 mb-1">Démarches déjà comprises dans le service : </h4>
                            <p className="small o-50">Déselectionnez les démarches que le défunt n'a pas.</p>
                            <form className="pb-sm">
                                <div className="grid grid-sm-min grid-lg-tight grid-xl-single g-spacer">
                                    {R.sortWith([R.ascend(R.prop('title'))])(Object.values(CommonServices)).map((srv, index) => {
                                        return (
                                            personalService(srv, index)
                                            // <div key={index + srv.title} className="form-group col col-lg-3 col-xl-2">
                                            //     <div className="card card-body text-center picker-card required no-event">
                                            //         <img className="img-fluid mx-auto my-3 mb-1 h-6 py-1" src={srv.icon} alt={srv.title} />
                                            //         <h2 className="h6 text-uppercase font-weight-bolder my-auto">{srv.title}</h2>
                                            //         {/* <i className={"picker-icon eva eva-checkmark-circle-outline"}></i> */}
                                            //     </div>
                                            // </div>
                                        );
                                    })}
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
                :
                <div className="auto-view py-4 py-lg-0 mt-lg-sm">
                    <div className="container-fluid">
                        <section className="block">
                            <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-0 mb-1">Vie quotidienne à sélectionner : </h4>
                            <p className="small o-50">Vous devez sélectionner les organismes avec lesquels le défunt a un contrat ou un abonnement (paiement mensuel, trimestriel ou annuel).</p>
                            <form className="pb-sm">
                                <div className="grid grid-sm-min grid-lg-tight grid-xl-single g-spacer">
                                    {
                                        R.sortWith([R.ascend(R.prop('title'))])(Object.entries(PersonalServices).map(entry => entry[1])).map((srv, index) => {
                                            return (
                                                personalService(srv, index)
                                            )
                                        })
                                    }
                                    {
                                        Object.entries(OtherService).map(entry => entry[1]).map((srv, index) => {
                                            if(srv.connectionType === ConnectionTypes.activity || srv.connectionType === ConnectionTypes.pension || srv.connectionType === ConnectionTypes.otherActivity || srv.connectionType === ConnectionTypes.poleEmploi)
                                                return '';
                                            return (personalService(srv, index + (PersonalServices.length)))
                                        })
                                    }
                                </div>
                            </form>
                        </section>
                        <section className="block mt-5 pt-2">
                            <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-3">RÉSEAUX SOCIAUX ( à sélectionner) </h4>
                            <form className="pb-sm">
                                <div className="grid grid-sm-min grid-lg-tight grid-xl-single g-spacer">
                                    {
                                         R.sortWith([R.ascend(R.prop('title'))])(Object.entries(SocialNetworksOptions).map(entry => entry[1])).map((srv, index) => {
                                            return (
                                                <div key={'social'+(index + srv.title)} className="form-group col col-lg-3 col-xl-2">
                                                    <div className={"card card-body pt-2 text-center picker-card" + (selectedServices.findIndex(s => s.connectionType === srv.connectionType) !== -1 ? ' active' : '')} onClick={() => { AddOrRemove(srv); }}>
                                                        <img className="img-fluid mx-auto my-3 mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
                                                        <h2 className="h6 text-uppercase font-weight-bolder container-slim m-auto">{srv.title}</h2>
                                                        {/* <i className={"picker-icon eva eva-" + (selectedServices.findIndex(s => s.connectionType === srv.connectionType) !== -1 ? 'checkmark-circle-outline' : 'radio-button-off-outline')}></i> */}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </form>
                        </section>
                        <section className="block mt-5 pt-2">
                            <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-3">ASSURANCES ( à selectionner) </h4>
                            <form className="pb-sm">
                                <div className="grid grid-sm-min grid-lg-tight grid-xl-single g-spacer">
                                    {
                                         R.sortWith([R.ascend(R.prop('title'))])(Object.entries(AssuranceOptions).map(entry => entry[1])).map((srv, index) => {
                                            return (
                                                <div key={'assurance'+(index + srv.title)} className="form-group col col-lg-3 col-xl-2">
                                                    <div className={"card card-body pt-2 text-center picker-card" + (selectedServices.findIndex(s => s.connectionType === srv.connectionType) !== -1 ? ' active' : '')} data-toggle={(srv.tooltip !== undefined ? "tooltip" : "")} data-placement={(srv.tooltip !== undefined ? "top" : "")} data-html={(srv.tooltip !== undefined ? "false" : "")} title={(srv.tooltip !== undefined ? srv.tooltip : "")} onClick={() => { AddOrRemove(srv); }}>
                                                        <img className="img-fluid mx-auto my-3 mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
                                                        <h2 className="h6 text-uppercase font-weight-bolder container-slim m-auto">{srv.title}</h2>
                                                        {/* <i className={"picker-icon eva eva-" + (selectedServices.findIndex(s => s.connectionType === srv.connectionType) !== -1 ? 'checkmark-circle-outline' : 'radio-button-off-outline')}></i> */}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            }
            <div className="container-fluid">
                <footer className="flex-md-row align-items-center mt-auto mb-sm text-lg-right w-100">
                    {
                        subStep === 1 ?
                            <Link to="/auth/signup/step3" className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link>
                            :
                            <button className="btn btn-faded px-md-gutter mr-3 ml-auto" onClick={() => { setSubStep(1) }}>Retour</button>
                    }
                    {
                        subStep === 1 ?
                            <button className="btn btn-info px-md-gutter px-4" onClick={() => { setSubStep(2) }}>Passer à l'étape suivante</button>
                            :
                            <button className={"btn btn-info loading-btn px-md-gutter px-4 loading-btn" + (user.isLoading.includes(Loadings.UPDATING_SERVICES) ? ' show' : '')}
                                disabled={user.isLoading.includes(Loadings.UPDATING_SERVICES)}
                                onClick={async () => {
                                    await dispatch(addUserServicesBatch(user.user, selectedServices));
                                    await dispatch(updateOnBoardingStep(4));
                                    setRedirect(true);
                                }}>Passer à l'étape suivante
                            <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                    }
                    <h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
                </footer>
            </div>
        </article>
    )
}